// Menu access
export const teacherMenu = ['superadmin','admin','subadmin', 'telecaller']
export const learnerMenu = ['superadmin','admin','subadmin', 'telecaller']
export const adminAccess = ['superadmin']
export const sessionMenu = ['superadmin','admin','subadmin',"reqhandler"]
export const adminAccess2 = ['superadmin','admin','subadmin']
export const campaignMenu = ['superadmin','admin','marketing']
export const bdaMenu = ['superadmin','admin','subadmin',"reqhandler"]
export const aiSessionsAccess = ['superadmin','admin']
export const fitnessAccess = ['superadmin','admin','subadmin']

// Routes access
export const home = ['superadmin','admin','subadmin','marketing', 'telecaller']
export const session = ['superadmin','admin','subadmin']
export const sessionRequest = ['superadmin','admin','subadmin',"reqhandler"]
export const downloadSessionreport = ['superadmin','admin', 'telecaller', 'subadmin']
export const createsession = ['superadmin','admin','subadmin']
export const subscribedusers = ['superadmin','admin','subadmin']
export const assignsession = ['superadmin','admin','subadmin']
export const subscriptiondetails = ['superadmin','admin','subadmin']
export const subscribedusersession = ['superadmin','admin','subadmin']
export const alllearners = ['superadmin','admin','subadmin']
export const learnerPayout = ['superadmin','admin']
export const analytics = ['superadmin','admin','subadmin']
export const coupons = ['superadmin','admin','subadmin']
export const affiliate = ['superadmin','admin']
export const affiliateProfile = ['superadmin','admin']
export const allTeacher = ['superadmin','admin','subadmin']
export const teacherProfile = ['superadmin','admin','subadmin','telecaller', 'bda_ai']
export const teacherSessionAttendance = ['superadmin','admin']
export const teacherTimeSlotsDetails = ['superadmin','admin','subadmin']
export const allLearner = ['superadmin','admin','subadmin','subadmin', 'telecaller', 'bda_ai']
export const learnerSessionAttendance = ['superadmin','admin','subadmin','telecaller']
export const upcoming = ['superadmin','admin','subadmin']
export const past = ['superadmin','admin','subadmin']
export const videoSessions = ['superadmin','admin','subadmin']
export const utmConversion = ['superadmin','admin','marketing']
export const utmCodeDetails = ['superadmin','admin','marketing']
export const sessiondoc = ['superadmin','admin','subadmin']
export const userfeedback = ['superadmin','admin','subadmin']
export const generatePaymentLink = ['superadmin','admin']
export const teacherquery = ['superadmin','admin','subadmin']
export const planlist = ['superadmin','admin','subadmin']
export const videoApproval = ['superadmin','admin','editor','reviewer']
export const courseAccess = ['superadmin','admin']
export const curriculumAccess = ['superadmin','admin']
export const demoTransactionAccess = ['superadmin','admin']
export const disputes = ['superadmin','admin','subadmin']
export const teacherConcern = ['superadmin','admin','subadmin']
export const resourceUpload = ['superadmin','admin',]
export const userStories = ['superadmin','admin','subadmin']
export const scheduleSession = ['superadmin','admin','subadmin']
export const subscriptionList = ['superadmin','admin','subadmin','telecaller']
export const uploadcsvfile = ['superadmin','admin']
export const bulkAICourseEnrollment = ['superadmin']
export const workshopAccess = ['superadmin','admin','subadmin']
export const workshopCommunityLinkAccess = ['superadmin','admin','subadmin']
export const learnerAssignments = ['superadmin','admin','subadmin']
export const bunnyStreamSetup = ['superadmin']
